import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { SNETButton } from "shared/dist/components";
import { PRICING_AND_DISTRIBUTION, PROFILE } from "../Routes";
import { aiServiceDetailsActions } from "../../../Services/Redux/actionCreators";
import { sections } from "../constant";
import { setCreateNewAiService } from "../../../Services/Redux/actionCreators/aiServiceDetailsActions";
import { useNavigateTo } from "../../../GlobalRouter/hook/NavigateTo";
import FormActions from "../../../Components/PageFormComponents/FormActions";

const Actions = ({ selectedFile }) => {
    const navigateTo = useNavigateTo();
    const { serviceStatus, selectedOrgUuid, serviceDetails, orgId } = useSelector(
        (state) => ({
            serviceDetails: state.aiServiceDetails,
            serviceStatus: state.aiServiceDetails.progressStages,
            selectedOrgUuid: state.organization.selectedOrganizationUuid,
            orgId: state.organization.id,
        }),
        shallowEqual
    );
    const [isContinueButtonDisable, setIsContinueButtonDisable] = useState(false);

    useEffect(() => {
        const isSelectedFileEmpty = !selectedFile.size;
        setIsContinueButtonDisable(
            Boolean(
                isSelectedFileEmpty &&
                !serviceDetails.assets.demoFiles.url &&
                serviceDetails.demoComponentAvailable
            )
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceDetails]);

    const { serviceUuid } = useParams();
    const dispatch = useDispatch();

    const handleBack = () => {
        navigateTo.aiServiceCreation({ orgUuid: selectedOrgUuid, serviceUuid }, PROFILE.path);
    };

    const handleSave = async () => {
        await dispatch(aiServiceDetailsActions.saveServiceDetails(selectedOrgUuid, serviceDetails));
        await dispatch(
            aiServiceDetailsActions.getServiceDetails(selectedOrgUuid, serviceUuid, orgId)
        );
        dispatch(
            aiServiceDetailsActions.updateProgressStatus(
                sections.SETUP_DEMO,
                serviceDetails.assets.demoFiles.status,
                serviceStatus
            )
        );
    };

    const handleContinue = async () => {
        await handleSave();
        navigateTo.aiServiceCreation(
            { orgUuid: selectedOrgUuid, serviceUuid },
            PRICING_AND_DISTRIBUTION.path
        );
    };

    const handleFinishLater = async () => {
        dispatch(setCreateNewAiService(false));
        await handleSave();
        navigateTo.services({ orgUuid: selectedOrgUuid });
    };

    return (
        <FormActions>
            <SNETButton variant="outlined" children="finish later" onClick={handleFinishLater} />
            <SNETButton variant="outlined" children="previous step" onClick={handleBack} />
            <SNETButton
                color="primary"
                variant="contained"
                children="continue"
                disabled={isContinueButtonDisable}
                onClick={handleContinue}
            />
        </FormActions>
    );
};

export default Actions;
